export default "/_next/static/images/2018-2x-810e4dce7c1d5f3676937ade5a075d6a.png";